import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';

const AnnouncementBar = ({ onClose }) => {
    const [nextEvent, setNextEvent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNextEvent = async () => {
            try {
                // Get current date to filter past events
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                // Fetch events sorted by date
                // Note: Depending on date string format, client-side filtering might be safer
                const q = query(collection(db, 'events'), orderBy('date', 'asc'));
                const querySnapshot = await getDocs(q);

                const events = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // Find the first event that is in the future
                const upcoming = events.find(event => {
                    const eventDate = new Date(event.date);
                    return eventDate >= today;
                });

                if (upcoming) {
                    setNextEvent(upcoming);
                }
            } catch (error) {
                console.error("Error fetching announcement:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchNextEvent();
    }, []);

    if (loading) return null; // Or show specific loading state, or just nothing until loaded

    return (
        <div className="bg-gradient-to-r from-[#A2CB52] to-[#B5D575] py-3 px-4 text-center relative z-50">
            <p className="text-[#20222D] font-bold text-sm md:text-base">
                {nextEvent ? (
                    <>
                        <span className="hidden sm:inline">Upcoming Webinar: </span>
                        {nextEvent.title} — Limited Seats.
                        <Link
                            to="/training/webinars"
                            className="ml-3 underline hover:no-underline font-bold"
                        >
                            Register Free →
                        </Link>
                    </>
                ) : (
                    <>
                        Note: <span className="hidden sm:inline">Upcoming events with limited seats only.</span>
                        <Link
                            to="/training/webinars"
                            className="ml-3 underline hover:no-underline font-bold"
                        >
                            View Schedule →
                        </Link>
                    </>
                )}
            </p>
            <button
                onClick={onClose}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-200"
            >
                <X size={20} />
            </button>
        </div>
    );
};

export default AnnouncementBar;
